import React from 'react'

import { useState } from "react";
import { useSearchParams, Outlet } from "react-router-dom";

import { StatisticsContext } from "@/contexts/StatisticsContext";
import { Box, Checkbox, Container, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";

import { Autocomplete } from "@mui/lab";

import { useSearchParam } from "@/hooks";

import i18n from '@/i18n'

import client from '@/client'
import { gql } from "@apollo/client";
import moment from 'moment';

const BREAKDOWN_TYPES = [
  'track',
  'label',
  'organization'
]


const STAGES = [
  {
    id: 'MID',
    name: 'mid-campaign'
    },
    {
    id: 'END',
    name: 'end-of-campaign'
    }
]

export function StatisticsLayout() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [labelQuery, setLabelQuery] = useState('')
  const [organizationQuery, setOrganizationQuery] = useState('')
  const [artistQuery, setArtistQuery] = useState('')
  const [artists, setArtists] = useState([])
  const [labels, setLabels] = useState([])
  const [organizations, setOrganizations] = useState([])
  const [selectedOrganizations, setSelectedOrganizations] = useSearchParam('organization', undefined, 'json',  true)
  const [end, setEnd] = useSearchParam('end', moment().subtract(2, 'days'), 'date', false)
  const [start, setStart] = useSearchParam('start', moment().subtract(8, 'days'), 'date', false)
  const [selectedLabels, setSelectedLabels] = useSearchParam('label', undefined, 'json', true)
  const [selectedArtists, setSelectedArtists] = useSearchParam('artist', undefined, 'json', true)
  const [selectedRecordings, setSelectedRecordings] = useSearchParam('recording', undefined, 'json', true)
  const [breakdown, setBreakdown] = useSearchParam('breakdown', 'track')
  const [stage, setStage] = useSearchParam('stage', 'END')
  
  return (
    <StatisticsContext.Provider
      value={{
        selectedOrganizations,
        setSelectedOrganizations,
        selectedLabels,
        setSelectedLabels,
        selectedArtists,
        setSelectedArtists,
        selectedRecordings,
        setSelectedRecordings,
        artists,
        setArtists,
        labels,
        setLabels,
        organizations,
        start,
        setOrganizations,
        breakdown,
        setBreakdown,
        stage,
        setStage,
        setStart,
        end,
        setEnd
      }}
    >
      <Outlet />
    </StatisticsContext.Provider>
  )
}